// Packages
import React, { useState, useCallback, useMemo } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  Button,
  Card,
} from "reactstrap";
import axios from "axios";
// Utils
import { catchHandler } from "../utils";
// Styling
import "./ForgotPassword.css";

const ForgotPassword = React.memo((props) => {
  const rootPathname = useMemo(() => "/login", []);
  const [loading, setLoading] = useState(false);
  const [fields, setFields] = useState({
    email: "",
  });
  const [errors, setErrors] = useState({});
  const history = useHistory();

  const onSubmit = useCallback(
    (event) => {
      event.preventDefault();

      setLoading(true);
      setErrors({});

      axios
        .post("/api/auth/reset-password", fields)
        .then((res) => {
          const { email } = res.data;
          toast.success(`Daca email-ul [${email}] are un cont asociat, veti primi la aceasta adresa un link pentru resetarea parolei.`);
          history.push(rootPathname);
        })
        .catch((err) => {
          const { email = "" } = catchHandler(history, err);
          setLoading(false);
          setErrors({ email });
        });
    },
    [history, fields, rootPathname]
  );

  const onKeyUp = useCallback(
    (event) => {
      if (event.key === "Enter") {
        onSubmit(event);
      }
    },
    [onSubmit]
  );

  const onCancel = useCallback(
    (event) => {
      event.preventDefault();
      history.push(rootPathname);
    },
    [history, rootPathname]
  );

  const onInputChange = useCallback((event) => {
    const { target = {} } = event;
    const { name, value } = target;
    setFields((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  return (
    <Container className="mt-5 mb-5">
      <Row>
        <Col sm="12" md={{ size: 8, offset: 2 }} lg={{ size: 6, offset: 3 }}>
          <Card className="p-5 bg-light shadow-sm">
            <h2 className="mb-5 mx-auto text-center">Recuperare Parola</h2>
            <Form onKeyUp={onKeyUp}>
              <FormGroup>
                <Label for="email">Email</Label>
                <Input
                  id="email"
                  name="email"
                  type="text"
                  invalid={Boolean(errors["email"])}
                  value={fields["email"]}
                  onChange={onInputChange}
                />
                <FormFeedback>{errors["email"]}</FormFeedback>
              </FormGroup>
              <FormGroup className="d-flex justify-content-between mt-5">
                <Button
                  type="submit"
                  color="primary"
                  onClick={onSubmit}
                  disabled={loading}
                >
                  Trimitere
                </Button>
                <Button outline color="secondary" onClick={onCancel}>
                  Renuntare
                </Button>
              </FormGroup>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
});

export default ForgotPassword;
